import React, { Component } from 'react'
import { Link } from 'gatsby'
import {
  Layout,
  Header,
  Showcase,
  SectionTitle,
  Intro,
} from '../../../../components'

import StepGuide from './step-guide'
import data from './data.json'
import './style.scss'
import pic from '../../../../images/stepguide.jpg'
//import pic_mobile from '../../../../images/pic_mobile.jpg'
//import pic_tablet from '../../../../images/pic_tablet.jpg'
//import pic_desktop from '../../../../images/pic_desktop.png'

export default class StepGuidePage extends Component {
  constructor(props) {
    super(props)
    this.stepGuideRef = React.createRef()
  }

  toggleExample = () => {
    this.stepGuideRef.current.toggle()
  }
  render() {
    return (
      <>
        <Header
          site={data.site}
          slug={data.slug + '/design/'}
          title={data.title}
          exclusive={true}
          state="design"
        />
        <Layout
          category="Overview"
          site={data.site}
          slug={data.slug + '/design/'}
          state="design"
          title={data.title}
        >
          <Intro>
            <p>
              The step guide pattern takes the user through a series of steps in
              order to complete a particular task. It is similar in structure to
              a{' '}
              <Link
                class="link"
                to={'/' + data.site + '/patterns/modal/design'}
              >
                modal
              </Link>
              , and the fullscreen container always usurps control of the
              window. The required elements are the "Close" action, the guide
              title, the step title, body content and a customized version of
              the persistent{' '}
              <Link
                class="link"
                to={'/' + data.site + '/patterns/action-group/design'}
              >
                action group
              </Link>{' '}
              pattern, which allows the user to navigate forward and backward in
              the step order. Body content will vary depending on the task. Add
              a guide description to briefly summarize the body content when
              necessary. A{' '}
              <Link
                class="link"
                to={'/' + data.site + '/patterns/divider/design'}
              >
                divider
              </Link>{' '}
              may be used to separate the description from body content.
            </p>
          </Intro>

          <SectionTitle>Variants</SectionTitle>
          <p>
            Step guides are designed responsively. A design asset is available
            for each breakpoint.
          </p>
          <Showcase
            site={data.site}
            title="Default"
            text="Signals that the body content is in the initial scroll position, or that there is nothing to scroll. Note that the persistent action group always appears with a medium shadow, even when there is no content overflow."
            oversized={true}
            handler={this.toggleExample}
          >
            <img class="step-guide_image" src={pic} alt="Default step guide" />
            <StepGuide ref={this.stepGuideRef} />
          </Showcase>
          <Showcase
            site={data.site}
            title="On Scroll"
            text="Signals that the body content has started to scroll. The shadowed header container showing the step guide title appears as the guide content scrolls."
            oversized={true}
            handler={this.toggleExample}
          >
            <img
              class="step-guide_image"
              src={pic}
              alt="Step guide on scroll"
            />
          </Showcase>
          <hr />
          <SectionTitle>Design Environment</SectionTitle>
          <p>
            The primary button will always drive the user forward in the flow,
            and the left arrow button will always bring the user back to the
            previous step.The progress bar and step label communicate to the
            user where they are in the step order. If the only purpose of the
            final step is confirmation, remove it and use a success{' '}
            <Link
              class="link"
              to={'/' + data.site + '/components/notification/design'}
            >
              notification
            </Link>{' '}
            instead. Step guides take over the entire screen in all
            environments, so they can only be dismissed with the "Close" action.
          </p>

          {/* <Showcase
          site={data.site}
          title="Moblie"
          text="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
        >
          <img class="step-guide_image_mobile" src={pic_mobile} alt="Mobile" />
        </Showcase>
        <Showcase
          site={data.site}
          title="Tablet"
          text="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
        >
          <img class="step-guide_image" src={pic_tablet} alt="Tablet" />
        </Showcase>
        <Showcase
          site={data.site}
          title="Desktop"
          text="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
        >
          <img class="step-guide_image" src={pic_desktop} alt="Desktop" />
        </Showcase> */}
          <hr />
          <SectionTitle>Microcopy</SectionTitle>
          <p>
            The guide description should be as brief as possible, ideally one or
            two sentences. Try to keep text content in the body concise to avoid
            scrolling if possible. The primary button will usually be "Next" or
            "Submit," depending on the step. Do not duplicate the "Close" action
            with a "Close" button in the last step. Otherwise, follow guidelines
            for the{' '}
            <Link
              class="link"
              to={'/' + data.site + '/components/title/design'}
            >
              title
            </Link>{' '}
            and{' '}
            <Link
              class="link"
              to={'/' + data.site + '/components/button/design'}
            >
              button
            </Link>{' '}
            components.
          </p>
        </Layout>
      </>
    )
  }
}
